import React, { useEffect, useState } from "react";
import { t } from "i18next";
import {
  Button,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Input,
  Spinner,
} from "reactstrap";

export const OpeningHours = ({ isOpen, toggle, info }) => {
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (info) {
      setLoading(false);
    }
  }, [info]);

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="lg">
      <ModalHeader toggle={toggle}>{t("View Opening Hours")}</ModalHeader>
      <ModalBody>
        {loading ? (
          <div className="text-center">
            <Spinner color="primary" />
            <p>{t("Loading Schedule...")}</p>
          </div>
        ) : (
          <>
            {/* Timezone Display */}
            <div className="mb-4">
              <Label className="fw-semibold">{t("Timezone")}</Label>
              <Input
                type="text"
                value={info.openingHours[0]?.timezone || "+00:00"}
                readOnly
                className="form-control"
              />
            </div>

            {/* Opening Hours List */}
            <div className="d-flex flex-column gap-3">
              {info.openingHours.map((hour, index) => (
                <div key={index} className="d-flex gap-3 align-items-center">
                  <div style={{ minWidth: "120px" }}>
                    <Input
                      type="text"
                      value={t(hour.dayOfWeek).toUpperCase()}
                      readOnly
                      className="form-control text-center fw-semibold"
                    />
                  </div>
                  <div className="flex-fill">
                    <div className="position-relative">
                      <Input
                        type="text"
                        value={hour.openTime}
                        readOnly
                        className="form-control"
                      />
                      <span
                        className="position-absolute"
                        style={{
                          right: "10px",
                          top: "50%",
                          transform: "translateY(-50%)",
                        }}
                      >
                        🕐
                      </span>
                    </div>
                  </div>
                  <div className="flex-fill">
                    <div className="position-relative">
                      <Input
                        type="text"
                        value={hour.closeTime}
                        readOnly
                        className="form-control"
                      />
                      <span
                        className="position-absolute"
                        style={{
                          right: "10px",
                          top: "50%",
                          transform: "translateY(-50%)",
                        }}
                      >
                        🕐
                      </span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </>
        )}
      </ModalBody>
      <ModalFooter>
        <Button color="danger" outline onClick={() => toggle()}>
          {t("Cancel")}
        </Button>
      </ModalFooter>
    </Modal>
  );
};